exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gift_card_tabs[data-v-57c053fe] {\n  padding: 12px;\n}\n", ""]);

// exports
